import React from "react";
import Clients from "./Clients";
import ServicesCard from "../../components/ServicesCard"
import AboutBlock from "./AboutBlock";
import BlogBlock from "./BlogBlock";
import TechBlock from "../TechBlock";
import DomainsBlock from "../DomainsBlock";
import NumbersBlock from "../NumbersBlock";
import { Container, Row, Col, Card } from 'react-bootstrap';
import './HomeStyle.css';
import { Link } from 'react-router-dom';


function Home() {
    return (
        <div>
            <section className="home-section background-image-container">
                <Container>
                    <Row className="padding-section-large">
                        <Col md={7}>
                            <h2 className="heading-style-h2 text-white">Offshore Software<br /> Development Company</h2>
                            <h2 className="heading-style-h2 text-gradient pt-3">for Complex, High-<br />Growth Systems</h2>
                            <h5 className="text-white heading-style-h5 py-4">Making intricate software environments easier to shape, strengthen, and sustain. </h5>
                            <Link to="/contact" className="btn btn-outline-light ls-10 rounded-pill text-uppercase">Talk to Out Experts</Link>
                        </Col>
                    </Row>
                </Container>
            </section>
            <ServicesCard />
            <NumbersBlock />
            <DomainsBlock />
            <Clients />
            <section className='py-5 bg-dark'>
                <Container>
                    <Row className="text-white">
                        <Col md={9}>
                            <h2 className="heading-style-h2 pb-3">What Sets Us Apart, <span className="text-gradient-1">In Practice</span></h2>
                            <h5 className='heading-style-h5 pb-5'>No over-engineering. No shortcuts. Just software that works under real-world pressure. </h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={4} className="pb-4 pb-md-0">
                            <Card className="rounded-0 dark-card">
                                <Card.Body className='p-4 d-flex flex-column'>
                                    <h5 className="heading-style-h5">Client-Centric Approach to Every Engagement  </h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4} className="pb-4 pb-md-0">
                            <Card className="rounded-0 dark-card">
                                <Card.Body className='p-4 d-flex flex-column'>
                                    <h5 className="heading-style-h5">Focus on Stability and Reliable Delivery</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={4}>
                            <Card className="rounded-0 dark-card">
                                <Card.Body className='p-4 d-flex flex-column'>
                                    <h5 className="heading-style-h5">Experience Handling Complex Business Systems </h5>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                    <Row className="mt-4">
                        <Col md={6} className="pb-4 pb-md-0">
                            <Card className="rounded-0 dark-card">
                                <Card.Body className='p-4 d-flex flex-column'>
                                    <h5 className="heading-style-h5">Tailored Technology Strategies, Not One-Size Solutions</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                        <Col md={6}>
                            <Card className="rounded-0 dark-card">
                                <Card.Body className='p-4 d-flex flex-column'>
                                    <h5 className="heading-style-h5">Teams That Integrate Seamlessly with Your Workflow</h5>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </section>
            <AboutBlock />
            <TechBlock />
            <BlogBlock />
        </div >
    );
}

export default Home;